import { general } from './general';

export const height = (data = {}) => general('height', {
  feet: data.feet || '',
  inches: data.inches || '',
});
